export enum MOVES_TYPES {
  creation = 'Inclusão',
  update = 'Alteração',
  removal = 'Exclusão',
}
